<ion-header>
  <ion-toolbar>
    <ion-title>{{
      isEditMode ? "Edit Collection" : "Create New Collection"
    }}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onCancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content">
  <form [formGroup]="collectionForm" (ngSubmit)="onSubmit()">
    <!-- Icon Selection Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Collection Icon <span class="optional">(Optional)</span>
          </ion-label>
          <div class="icon-selection-container">
            <ion-button
              fill="clear"
              (click)="selectIcon()"
              class="icon-selection-button"
              [title]="selectedIcon ? 'Change Icon' : 'Choose Icon'"
            >
              <div class="icon-preview">
                <div *ngIf="currentIconComponent">
                  <lucide-icon
                    [img]="currentIconComponent"
                    class="selected-icon"
                  ></lucide-icon>
                </div>
                <div *ngIf="!currentIconComponent" class="icon-placeholder">
                  <ion-icon
                    name="add-outline"
                    class="placeholder-icon"
                  ></ion-icon>
                </div>
              </div>
              <span class="icon-selection-text">
                {{ selectedIcon ? "Change Icon" : "Choose Icon" }}
              </span>
            </ion-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Collection Name Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Collection Name <span class="required">*</span>
          </ion-label>
          <ion-input
            formControlName="name"
            placeholder="Enter collection name"
            class="form-input"
            [class.invalid]="
              collectionForm.get('name')?.invalid &&
              collectionForm.get('name')?.touched
            "
          ></ion-input>
          <div
            *ngIf="
              collectionForm.get('name')?.invalid &&
              collectionForm.get('name')?.touched
            "
            class="error-message"
          >
            Collection name is required
          </div>
        </div>
      </div>
    </div>

    <!-- Description Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Description <span class="optional">(Optional)</span>
          </ion-label>
          <ion-textarea
            formControlName="description"
            placeholder="Enter collection description"
            rows="3"
            auto-grow="true"
            class="form-textarea"
          ></ion-textarea>
        </div>
      </div>
    </div>
  </form>
</ion-content>

<ion-footer class="modal-footer">
  <ion-button
    fill="clear"
    (click)="onCancel()"
    [disabled]="isLoading"
    color="medium"
  >
    Cancel
  </ion-button>
  <ion-button
    (click)="onSubmit()"
    [disabled]="!collectionForm.valid || isLoading"
  >
    <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
    <span *ngIf="!isLoading">{{ isEditMode ? "Save" : "Create" }}</span>
  </ion-button>
</ion-footer>
